import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-hash-02',
  imports: [],
  templateUrl: './hash-02.html',
  styleUrl: './hash-02.scss',
})
export class Hash02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
